import React, { useState, useCallback, useEffect, useRef } from 'react';
import Toast from './Toast';
import './Toast.css';
import { setToastContainer } from './toastUtils';

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);
  const containerRef = useRef(null);

  const addToast = useCallback((message, duration = 5000) => {
    const id = Date.now().toString() + Math.random().toString(36).substr(2, 9);
    setToasts(prev => [...prev, { id, message, duration }]);
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  // Expose addToast method to toastUtils
  useEffect(() => {
    if (containerRef.current) {
      setToastContainer({
        addToast
      });
    }
  }, [addToast]);

  return (
    <div className="toast-container" ref={containerRef}>
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          id={toast.id}
          message={toast.message}
          duration={toast.duration}
          onClose={removeToast}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
